import { Validators } from "@angular/forms";
import { environment } from "src/environments/environment";
import { AwsService } from "../services/aws/aws.service";
import { DiscountPeriod } from "./discount-period-model";

export class Studio {
  id?: number;
  slug?: string;
  name?: string;
  private_name?: string;
  phone!: string;
  country_phone!: string;
  country_code_phone!: string;
  email?: string;
  siren?: string;
  description?: string;
  web_site?: string;
  ical_link?: string;
  is_deleted: boolean = false;
  is_sponsored: boolean = false;
  is_draft: boolean = false;
  cover?: any;
  thumbnail: string = "";
  stripe_is_verify: boolean = false;
  max_capacity: number = 0;
  type_name: string = "";
  webflow_slug: string = "";
  webflow_id: string = "";

  prestations: Array<string> = [];

  youtube_link: string = "";
  twitter_link: string = "";
  tiktok_link: string = "";
  instagram_link: string = "";
  facebook_link: string = "";

  price: number = 0;
  active_promo: boolean = false;
  price_promo: number = 0;

  nbr_min_hours: number = 0;

  street_number: string = "";
  street: string = "";
  city?: string;
  country?: string;
  postal_code?: string;
  full_address?: string;
  departement?: string;

  count_booking: number = 0;
  payouts_enabled: boolean = false;
  is_partner: boolean = false;

  promo_code_text: string = "";
  promo_code_value: string = "";
  discount_periods: DiscountPeriod[];

  constructor(data?: Partial<Studio>) {
    if (data) {
      Object.assign(this, data);

      if (data.id !== undefined) {
        if (this.thumbnail == "") {
          if (data.cover) {
            this.thumbnail = AwsService.generate_link(
              data.cover.formats.thumbnail.url
            );
          } else {
            this.thumbnail = environment.default_cover;
          }
        }
      }
    }
  }

  static attributeDataToJson(item: any) {
    let obj = item.data.attributes;
    obj["id"] = item.data.id;

    if (item.data.attributes.cover) {
      obj["cover"] =
        item.data.attributes.cover.data == null
          ? null
          : item.data.attributes.cover.data.attributes;
    } else {
      obj["cover"] = null;
    }
    obj["thumbnail"] =
      obj["cover"] == null
        ? environment.default_cover
        : AwsService.generate_link(obj["cover"].url);

    let array_galeries = [];
    if (
      item.data.attributes.galeries != null &&
      item.data.attributes.galeries != undefined &&
      item.data.attributes.galeries.data != null &&
      item.data.attributes.galeries.data != undefined
    ) {
      item.data.attributes.galeries.data.forEach((itemGalery: any) => {
        let objGallery = itemGalery.attributes;
        objGallery["id"] = itemGalery.id;
        objGallery["thumbnail"] = AwsService.generate_link(objGallery.url);
        array_galeries.push(objGallery);
      });
    }

    obj["galeries"] = array_galeries;

    let array_discount_periods = [];
    if (
      item.data.attributes.discount_periods != null &&
      item.data.attributes.discount_periods != undefined &&
      item.data.attributes.discount_periods.data != null &&
      item.data.attributes.discount_periods.data != undefined
    ) {
      item.data.attributes.discount_periods.data.forEach((item: any) => {
        let objDiscount = item.attributes;
        objDiscount["id"] = item.id;
        array_discount_periods.push(objDiscount);
      });
    }

    obj["discount_periods"] = array_discount_periods;

    return obj;
  }

  static attributeToJson(item: any) {
    let obj = item.attributes;
    obj["id"] = item.id;

    if (item.attributes.cover) {
      obj["cover"] =
        item.attributes.cover.data == null
          ? null
          : item.attributes.cover.data.attributes;
    } else {
      obj["cover"] = null;
    }
    obj["thumbnail"] =
      obj["cover"] == null
        ? environment.default_cover
        : AwsService.generate_link(obj["cover"].url);

    let array_galeries = [];
    if (
      item.attributes.galeries != null &&
      item.attributes.galeries != undefined &&
      item.attributes.galeries.data != null &&
      item.attributes.galeries.data != undefined
    ) {
      item.attributes.galeries.data.forEach((itemGalery: any) => {
        let objGallery = itemGalery.attributes;
        objGallery["id"] = itemGalery.id;
        objGallery["thumbnail"] = AwsService.generate_link(objGallery.url);
        array_galeries.push(objGallery);
      });
    }

    obj["galeries"] = array_galeries;

    return obj;
  }

  static responseToJson(item: any) {
    let obj = item;

    if (item.cover) {
      obj["cover"] = item.cover == null ? null : item.cover;
    } else {
      obj["cover"] = null;
    }
    obj["thumbnail"] =
      obj["cover"] == null
        ? environment.default_cover
        : AwsService.generate_link(obj["cover"].url);

    let array_galeries = [];
    if (
      item.galeries != null &&
      item.galeries != undefined &&
      item.galeries != null &&
      item.galeries != undefined
    ) {
      item.galeries.forEach((itemGalery: any) => {
        let objGallery = itemGalery;

        objGallery["thumbnail"] = AwsService.generate_link(
          objGallery.formats["thumbnail"].url
        );
        array_galeries.push(objGallery);
      });
    }

    obj["galeries"] = array_galeries;

    return obj;
  }

  static get_title() {
    return "Ajouter un nouveau studio";
  }

  static get_inputs() {
    return [
      /*
      {
        name: "is_draft",
        type: "switch",
        label: "Brouillon",
        readOnly: false,
      },
      {
        name: "slug",
        type: "text",
        label: "Slug",
        readOnly: true,
      },
      {
        name: "name",
        type: "text",
        label: "Nom public",
        readOnly: false,
      },
      */
      {
        name: "private_name",
        type: "text",
        label: "Nom",
        readOnly: false,
      },
      {
        name: "type_name",
        type: "enum-object",
        label: "Type de studio",
        list: [
          { key: "ENREGISTREMENT", text: "ENREGISTREMENT" },
          { key: "PHOTOGRAPHIE", text: "PHOTOGRAPHIE" },
          { key: "DJ", text: "DJ" },
          { key: "PODCAST", text: "PODCAST" },
        ],
        readOnly: false,
      },
      {
        name: "phone",
        type: "phone",
        label: "Numéro téléphone",
        field_country: "country_phone",
        field_code: "country_code_phone",
        readOnly: false,
      },
      {
        name: "email",
        type: "text",
        label: "Email",
        readOnly: false,
      },
      {
        name: "siren",
        type: "text",
        label: "Siren",
        readOnly: false,
      },
      {
        name: "nbr_min_hours",
        type: "number",
        label: "Nombre d'heures minimum de réservation",
        readOnly: false,
      },
      {
        name: "full_address",
        type: "address",
        label: "Adresse complet",
      },
      {
        name: "address",
        type: "address-item",
        label: "Adresse",
      },
      {
        name: "city",
        type: "address-item",
        label: "ville",
      },
      {
        name: "postal_code",
        type: "address-item",
        label: "Code postal",
      },
      {
        name: "departement",
        type: "address-item",
        label: "Département",
      },
      {
        name: "country",
        type: "address-item",
        label: "Pays",
      },
      {
        name: "lat",
        type: "address-item",
        label: "Latitude",
      },
      {
        name: "lng",
        type: "address-item",
        label: "Longitude",
      },
      {
        name: "description",
        type: "textarea",
        label: "Description",
        readOnly: false,
      },
      {
        name: "ical_link",
        type: "text",
        label: "Lien ical",
        readOnly: false,
      },
      {
        name: "price",
        type: "number",
        label: "Tarification",
        readOnly: false,
      },
      /*
      {
        name: "active_promo",
        type: "switch",
        label: "Activer promo",
        readOnly: false,
      },
      {
        name: "price_promo",
        type: "number",
        label: "Tarification promo",
        readOnly: false,
      },
      */
      {
        name: "web_site",
        type: "text",
        label: "Site web",
        readOnly: false,
      },
      {
        name: "youtube_link",
        type: "text",
        label: "Youtube",
        readOnly: false,
      },
      {
        name: "twitter_link",
        type: "text",
        label: "Twitter",
        readOnly: false,
      },
      {
        name: "tiktok_link",
        type: "text",
        label: "Tiktok",
        readOnly: false,
      },
      {
        name: "instagram_link",
        type: "text",
        label: "Instagram",
        readOnly: false,
      },
      {
        name: "facebook_link",
        type: "text",
        label: "Facebook",
        readOnly: false,
      },
      {
        name: "galeries",
        type: "galeries",
        label: "Photos",
        init_images: [],
        images: [],
        files: [],
      },
    ];
  }

  static get_form() {
    return {
      //slug: [""],
      //name: ["", Validators.required],
      private_name: ["", Validators.required],
      full_address: ["", Validators.required],
      address: ["", Validators.required],
      postal_code: ["", Validators.required],
      country: ["", Validators.required],
      city: ["", Validators.required],
      departement: [""],
      phone: [""],
      country_phone: [""],
      country_code_phone: [""],
      email: ["", Validators.required],
      siren: [""],
      description: [""],
      ical_link: [""],
      nbr_min_hours: [2, [Validators.required, Validators.min(0)]],
      type_name: ["ENREGISTREMENT", Validators.required],
      price: [0, [Validators.required, Validators.min(0)]],
      //active_promo: [false],
      //price_promo: [0, Validators.min(0)],
      prestations: [],
      web_site: [""],
      youtube_link: [""],
      twitter_link: [""],
      tiktok_link: [""],
      instagram_link: [""],
      facebook_link: [""],
      lat: [""],
      lng: [""],
    };
  }

  static get_relations() {
    return [
      {
        name: "cover",
        label: "",
        component: "image",
        endpoint: "",
        belongTo: "",
        model: null,
        index: "",
        array: [],
        selected: "",
      },
      {
        name: "prestations",
        label: "Liste des options",
        button_label: "",
        component: "multi-check",
        endpoint: "prestations",
        where_filter_field: "",
        index: "title",
        filters:
          "?pagination[pageSize]=25&pagination[page]=1&sort[0]=createdAt:desc",
        init_array: [],
        selected_array: [],
        show_button_add: false,
      },
      {
        label: "Localisation",
        component: "map",
        keys: ["lat", "lng"],
      },
      /*
      {
        name: "prestations",
        label: "Liste des options",
        button_label: "Ajouter une option",
        component: "multi-check",
        endpoint: "prestations",
        where_filter_field: "type_name",
        index: "title",
        filters:
          "?pagination[pageSize]=25&pagination[page]=1&sort[0]=createdAt:desc&filters[type_name]={where_filter_field}",
        init_array: [],
        selected_array: [],
        show_button_add: false,
      },
      */
    ];
  }
}
